import remoteLog from "./log";

const BACKOFF_START = 1000;
const BACKOFF_LIMIT = Math.pow(2, 8) * BACKOFF_START;

const RED_SESSION = 4100;
const BAD_ORIGIN = 4101;
const MISSING_ORIGIN = 4102;
const OAUTH_TOKEN = 4103;
const EMPTY_DS_COOKIE = 4104;
const EMPTY_SESSION = 4105;
//const SESSION_VERIFICATION_FAILURE = 4106;

const ERRORS_NO_RETRY = [RED_SESSION, BAD_ORIGIN, MISSING_ORIGIN, OAUTH_TOKEN, EMPTY_DS_COOKIE, EMPTY_SESSION];
const ERRORS_NO_LOG = [RED_SESSION, EMPTY_DS_COOKIE, EMPTY_SESSION];

export default class Connection {
	_ws: WebSocket | null;

	_openTimeout: number;

	_options: any;

	uid: any;

	_backoff: number;

	_lastSend: number;

	_lastReceive: number;

	constructor(options) {
		this._options = options;
		this._ws = null;
		this._backoff = BACKOFF_START;
		this._openTimeout = 0;
		this._lastSend = 0;
		this._lastReceive = 0;
		this.uid = null;
		this.open();
	}

	// eslint-disable-next-line class-methods-use-this
	onOpen() {}

	// eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
	onClose(willRetry) {}

	// eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-unused-vars
	onMessage(data) {}

	handleEvent(event: MessageEvent & { code: any }) {
		switch (event.type) {
			case "open":
				this._lastSend = 0;
				this._lastReceive = 0;

				clearTimeout(this._openTimeout);
				// eslint-disable-next-line no-console
				this._options.log && console.log("opened");
				this._ws = event.target as WebSocket;
				this.onOpen();
				break;

			case "close": {
				// eslint-disable-next-line no-console
				this._options.log && console.warn("close", event);
				this._ws = null;

				const shouldLog = ERRORS_NO_LOG.indexOf(event.code) === -1;

				if (shouldLog) {
					const lastSend = this._lastSend ? Date.now()-this._lastSend : 0;
					const lastReceive = this._lastReceive ? Date.now()-this._lastReceive : 0;

					remoteLog("ws-close", { code: event.code, backoff: this._backoff, lastSend, lastReceive });
				}

				if (!navigator.onLine) { // nejsme online: true znamena, ze se o to sami pokusime az budeme zase online (ale ted se schovaji ikonky)
					// this.onClose(true);
					return;
				}

				const shouldRetry = ERRORS_NO_RETRY.indexOf(event.code) === -1;

				if (shouldRetry) {
					// eslint-disable-next-line no-console
					this._options.log && console.log("waiting for", this._backoff);
					setTimeout(() => this.open(), this._backoff);
					if (this._backoff < BACKOFF_LIMIT) {
						this._backoff *= 2;
					}
				}

				this.onClose(shouldRetry);
				break;
			}

			case "message": {
				this._lastReceive = Date.now();

				this._backoff = BACKOFF_START; // dostali jsme data -> resetujeme citac exponencialniho backoffu

				const data = JSON.parse(event.data);

				// eslint-disable-next-line no-console
				this._options.log && console.log("%c🠜", "color:red", data);

				this.onMessage(data);
				break;
			}

			case "online":
				// eslint-disable-next-line no-console
				this._options.log && console.log("online");
				if (this._backoff === BACKOFF_START) {
					this.open();
				} // pokud nejsme v cekaci smycce, pokusit se pripojit
				break;

			case "offline":
				// eslint-disable-next-line no-console
				this._options.log && console.log("offline");
				this._backoff = BACKOFF_START;
				this._ws && this._ws.close(); // pokud jeste mame socket (tj. nebyl zavren drive chybou 1006), tak jej rucne strhneme
				break;

			default:
				//
		}
	}

	send(type, data: any = {}) {
		if (!this._ws) {
			return null;
		}
		this._lastSend = Date.now();

		const ts = window.performance ? performance.now() : Date.now();
		const rid = [ts, Math.random()].join("-");
		const dataOut = { type, rid, ...data };

		if (this.uid) {
			dataOut.uid = this.uid;
		}

		// eslint-disable-next-line no-console
		this._options.log && console.log("%c🠞", "color:green", dataOut);
		this._ws.send(JSON.stringify(dataOut));

		return rid;
	}

	close() {
		if (!this._ws) {
			return;
		}

		this._ws.removeEventListener("close", this);
		this._ws.close();
		this._ws = null;
	}

	open() {
		if (this._ws) {
			return;
		}

		const ws = new WebSocket(`${this._options.url}/ws/notifications`);

		ws.addEventListener("open", this);
		ws.addEventListener("close", this);
		ws.addEventListener("message", this);
		// error neposlouchame => nastane close

		window.addEventListener("online", this);
		window.addEventListener("offline", this);

		this._openTimeout = window.setTimeout(() => remoteLog("ws-connect-timeout"), 3000);
	}
}
